import { Rule } from "app/auth/permissions/rules";

export interface RoleTemplate {
    name: string;
    zoneRules: Rule[];
    groupRules: Rule[];
}

export const CUSTOM: RoleTemplate = {
    name: "Custom",
    zoneRules: [],
    groupRules: [],
}

export const HEALTH_BENEFITS_ADVOCATE: RoleTemplate = {
    name: "ABC - Health Benefits Advocate",
    zoneRules: [Rule.CHAT, Rule.SET_REMINDER, Rule.USE_CLIENT_EXTENSIONS],
    groupRules: [
        Rule.LOAD_ALGORITHM,
        Rule.POPULATE_SUBJECT,
        Rule.VIEW_SUBJECT,
        Rule.VIEW_COMMENT,
        Rule.COMMENT,
        Rule.SUBSCRIBE_SUBJECT,
        Rule.SEARCH_SUBJECT,
        Rule.EXPLAIN_SUBJECT,
    ],
};

export const REPORT_RUNNER: RoleTemplate = {
    name: "ABC - Report Runner",
    zoneRules: [Rule.CHAT, Rule.SET_REMINDER, Rule.USE_CLIENT_EXTENSIONS],
    groupRules: [
        Rule.LOAD_ALGORITHM,
        Rule.POPULATE_SUBJECT,
        Rule.VIEW_SUBJECT,
        Rule.VIEW_COMMENT,
        Rule.COMMENT,
        Rule.SUBSCRIBE_SUBJECT,
        Rule.SEARCH_SUBJECT,
        Rule.EXPLAIN_SUBJECT,
        Rule.CREATE_AGGREGATOR,
        Rule.RUN_AGGREGATOR,
        Rule.RUN_DATA_EXPORT,
        Rule.CREATE_DATA_EXPORT
    ],
}

export const roleTemplates = [HEALTH_BENEFITS_ADVOCATE, REPORT_RUNNER, CUSTOM];



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/management/constants.ts